import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditLead, CrmSidebar, LeadList } from "../../components/crm";
import { CRM_CREATE_LEAD } from "../../constants";
import { useHasPermission } from "../../utils";
import { usePersistedPageValue } from "../../hooks/usePersistedTableState";

const ALL_LEADS_STATUS = { statusId: null, statusName: "All Leads" };

const isLeadStatus = (value: unknown): value is { statusId: string | number | null; statusName: string } =>
  typeof value === "object" &&
  value !== null &&
  "statusId" in value &&
  "statusName" in value &&
  typeof value.statusName === "string";

export const Leads = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);
  // The sidebar status filter is remembered with the table: Back restores it, forward navigation starts from all leads.
  const [leadStatus, setLeadStatus] = usePersistedPageValue("lead-status", ALL_LEADS_STATUS, isLeadStatus);
  const { statusId: selectedStatus, statusName } = leadStatus;

  const hasCreateLead = useHasPermission(CRM_CREATE_LEAD);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const handleStatusClick = (statusDetails) => {
    setLeadStatus({ statusId: statusDetails.statusId, statusName: statusDetails.statusName });
  };

  // Check if the user has permission to create leads
  const buttons = [
    hasCreateLead && {
      buttonText: "Add Lead",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        <Box sx={{ display: "flex", marginLeft: "12px" }}>
          {/* crm sidebar */}
          <CrmSidebar onStatusClick={handleStatusClick} reloadData={reload} selectedStatusId={selectedStatus} />
          <Box component="main" sx={{ flexGrow: 1, position: "relative", minWidth: 0, width: "100%" }}>
            {/* header section */}
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <PageHeader
                // title
                title={`${statusName} (${totalCount})`}
                // button
                buttons={buttons}
              />
            </Box>

            {/* table section */}
            <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
              <LeadList
                leadFilter={selectedStatus}
                totalCount={totalCount}
                setTotalCount={setTotalCount}
                onSuccess={handleReload}
                reloadData={reload}
              />
            </Box>
          </Box>
        </Box>
      </PageLayout>

      {/* Add Lead modal*/}
      <AddEditLead open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
